import { useNavigationStore } from '@planning/stores'
import { useTranslate } from '@tolgee/react'
import { BackButton } from '@tom-ui/ui'

export const NavigationStackBackButton = () => {
  const navigationStore = useNavigationStore()
  const { t } = useTranslate()

  return <BackButton onGoBack={navigationStore.pop} tooltip={t('return', 'Return')} />
}
